export default "__VITE_ASSET__DE9hT0oD__"